module.exports = __webpack_public_path__ + "static/media/best_me_8.1d49069a.jpg";